import api from "./serverApi";

// Tweetleri getiren API fonksiyonu
export const getTweetsApi = async () => {
  try {
    const response = await api.get("/api/"); // Backend'deki tweet endpoint'i
    return response.data; // Dönen tweet verisi
  } catch (error) {
    console.error("Error fetching tweets:", error.response?.data || error.message);
    // Hata durumunda boş bir dizi veya uygun bir hata mesajı dönebiliriz
    return [];
  }
};
